__turbopack_context__.v({
  "desktopPrimaryOffers": "IUxCUq_desktopPrimaryOffers",
  "leftPanel": "IUxCUq_leftPanel",
  "mobilePrimaryOffers": "IUxCUq_mobilePrimaryOffers",
  "primaryOffersSlot": "IUxCUq_primaryOffersSlot",
  "rightPanel": "IUxCUq_rightPanel",
  "section": "IUxCUq_section",
  "stickyPanel": "IUxCUq_stickyPanel",
  "wrapper": "IUxCUq_wrapper",
});
